<template lang="html">

 <li class="keyword">
  <label>{{data}}</label>
  <button class="close" @click="sendErase">✕</button>
</li>

</template>

<script lang="js">
  export default  {
    name: 'keyword',
    props: ['data'],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {
      sendErase : function(){
        this.$emit('erase');
      }
    },
    computed: {

    }
  }
</script>

<style scoped>



li.keyword{
  width: auto;
  cursor: pointer;
  border:1px solid #054279;
  color: #054279;
  display: inline-block;
  padding-right: 30px;
  position: relative;
  height: 40px;
  line-height: 40px;
  margin-right: 15px;
}

.keyword .close{
  color: #054279;
  font-size: 16px;
  border: none;
  outline: none;
  background: transparent;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  line-height: 16px;
  cursor:pointer;
  z-index: 2;
}

.keyword label{
  padding: 0;
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  cursor: pointer;
  width: auto;
}

.keyword input:checked + label{
  border: 1px solid #054279;
}

.keyword input:checked + label::before{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/keyword.vue